export const setCookie = (
  name: string,
  value: string,
  days: number,
  sameSite?: boolean,
  secure?: boolean
) => {
  if (!document) return;
  let expires: string = '';
  if (days) {
    const date: Date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  const Secure: string = secure ? ' Secure;' : '';
  const SameSite: string = sameSite ? ` SameSite=${sameSite};` : '';
  const encodedValue: string = encodeURIComponent(value || '');
  document.cookie = `${name}=${encodedValue}${expires}; path=/;${SameSite}${Secure}`;
};

export const getCookie = (name: string) => {
  if (!document) return;
  const nameEqual: string = `${name}=`;
  const cookieArray: Array<string> = document.cookie.split('; ');
  const foundCookie: string | undefined = cookieArray.find((cookie) => cookie.includes(nameEqual));
  return foundCookie ? decodeURIComponent(foundCookie.replace(nameEqual, '')) : '';
};

export const eraseCookie = (name: string) => {
  if (!document) return;
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
